export default __webpack_public_path__ + "static/media/firebase.ef373c37.png";